/* eslint-disable @typescript-eslint/no-unused-vars */

xplenty.directive('variablesEditorRow', [
  '$timeout',
  function ($timeout) {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./variables-editor-row.html'),

      replace: true,

      scope: false,

      link(scope, element) {
        const availableFields = _.map(scope.$parent.schemaFields, function (schemaField) {
          return schemaField.alias;
        });

        $timeout(function () {
          const $cubeFieldsSelect = element.find('.selectpicker');

          $cubeFieldsSelect.selectpicker({
            iconBase: 'fa',
            tickIcon: 'fa-check',
          });

          $timeout(function () {
            element.find('[data-toggle="tooltip"]').tooltip();
          });

          const $input = element.find('.expression-code');

          const bindAutocomplete = function () {
            $input.autocomplete({
              minLength: 0,
              source(request, response) {
                const filteredArray = $.map(availableFields, function (item) {
                  if (item.startsWith(request.term)) {
                    return item;
                  }
                  return null;
                });
                response(filteredArray);
              },
            });
          };

          const unbindAutocomplete = function () {
            $input.autocomplete('destroy');
          };

          if ($input.length) {
            $input.focus(bindAutocomplete);
            $input.blur(unbindAutocomplete);
          }
        });
      },
      controller: ['$scope', '$rootScope', function ($scope, $rootScope) {}],
    };
  },
]);
